// @ts-nocheck

import { formatProjectImages } from './formatProjectImages'
import { isJSON } from './isJSON'

// Parse JSON in object
export function parseJSONinObject<T>(obj: T): T {
  let newObj: T | { images: T[] } = { ...obj }
  if (!obj) return

  // If the object is an array, loop through it
  Object.keys(obj).forEach(key => {
    if (!isJSON(obj[key]) || !key) return

    // Images need to be converted to image objects
    if (key === 'images') {
      newObj[key] = formatProjectImages(obj[key]) as T[]
    } else {
      newObj[key] = JSON.parse(obj[key])
      newObj[key] = isJSON(newObj[key]) ? JSON.parse(newObj[key]) : newObj[key]
    }
  })
  return newObj
}
